import { render, staticRenderFns } from "./topupDetails.vue?vue&type=template&id=52e2f908"
import script from "./topupDetails.vue?vue&type=script&lang=js"
export * from "./topupDetails.vue?vue&type=script&lang=js"
import style0 from "./topupDetails.vue?vue&type=style&index=0&id=52e2f908&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports